import basic from './basic';
import oll from './oll';

export default [
  oll,
  basic,
];
